import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';

import { getPropertyTypeTextToIDMapping } from './getListingRouteValues';

export const getListingTypeIdsFromQueryParam = (
  listingType: string[] | string | undefined,
) => {
  const propertyTypes: Array<PropertyTypeID> = [];
  if (listingType && Array.isArray(listingType)) {
    listingType.forEach(typeId => {
      propertyTypes.push(parseInt(typeId, 10) as unknown as PropertyTypeID);
    });
  }
  return propertyTypes;
};
export const getListingTypeIdsFromDynamicRoutes = (listingType: string) => {
  const propertyTypeID = getPropertyTypeTextToIDMapping(listingType);
  if (propertyTypeID === undefined) {
    return null;
  }
  return [propertyTypeID];
};
